import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import ActiviteitenPartners from "../components/ActiviteitenPartners";
import { IMAGES } from "../data/site";

const features = [
  { title: "5 springkastelen", text: "Maar liefst 5 springkastelen voor klimmen, springen en ravotten." },
  { title: "Extra kinderanimatie", text: "Elke woensdag- en zondagnamiddag is er extra kinderanimatie op het kinderstrand, met onder andere schmink, ballonnen, knutselen en speelse activiteiten." },
  { title: "Speelstrand", text: "Een veilige zandzone speciaal voor de kleinsten." },
  { title: "Kabouterwandeling", text: "Doe mee en zoek de kabouters verstopt op de wandelroute rond Mechelen Beach." },
];

// Hero uses kidsNewRommie · Wat te beleven uses kidsNewMascot · Gallery uses the other 4 + 2 different existing photos (no duplicates)
const gallery = [
  IMAGES.kidsNewSpringkasteel,
  IMAGES.kidsNewSchmink,
  IMAGES.kidsNewKnutselen,
  IMAGES.kidsActSkate,
  IMAGES.kidsActCirkus,
  IMAGES.kidsActBoog,
];

export default function Kinderstrand() {
  return (
    <>
      <Seo
        title="Kinderstrand | Mechelen Beach 2026"
        description="Het Kinderstrand van Mechelen Beach 2026 — 5 springkastelen, kinderanimatie en zomers familieplezier op het Douaneplein."
      />

      <PageHero
        eyebrow="Kinderstrand"
        title="Spelen, ontdekken en genieten"
        subtitle="Het Kinderstrand zorgt voor een gezellige en speelse omgeving voor kinderen en families. Springkastelen, zand en de allerleukste momenten — terwijl de ouders genieten van een drankje."
        image={IMAGES.kidsNewRommie}
        imageAlt="Kinderen spelen samen in het zand op het Kinderstrand van Mechelen Beach"
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        secondaryCta={{ label: "Meer info", to: "/contact" }}
      />

      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <span className="eyebrow">Wat te beleven</span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
                Een onvergetelijke zomer voor het hele gezin
              </h2>
              <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
                Maar liefst <span className="font-semibold text-[#2b1c10]">5 springkastelen</span> zorgen
                voor extra speelplezier op het kinderstrand.
              </p>
              <p className="mt-4 text-base sm:text-lg text-[#6b5945] leading-relaxed">
                Extra activiteiten elke woensdagnamiddag en zondagnamiddag: schmink, ballonnen,
                knutselen en speelse activiteiten.
              </p>
              <div className="mt-8 grid grid-cols-2 gap-4">
                {features.map((f, i) => (
                  <div
                    key={f.title}
                    data-testid={`kinderstrand-card-${i}`}
                    className="bg-white rounded-xl border border-[#ebd9b5] p-4"
                  >
                    <p className="font-display font-semibold text-[#2b1c10]">{f.title}</p>
                    <p className="mt-1 text-xs text-[#6b5945] leading-relaxed">{f.text}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="photo">
              <img
                src={IMAGES.kidsNewMascot}
                alt="Kinderen geven een high-five aan de Mechelen Beach mascotte op het zand"
                className="w-full h-[360px] sm:h-[480px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-sand-2 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Sfeerbeelden</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Plezier in beeld
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
            {gallery.map((src, i) => (
              <div key={i} data-testid={`kinderstrand-gallery-${i}`} className="overflow-hidden rounded-xl aspect-square group">
                <img
                  src={src}
                  alt={`Kinderstrand sfeer ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <ActiviteitenPartners
        text="Deze partners zorgen mee voor extra kinderactiviteiten, spel, animatie en beleving tijdens Mechelen Beach."
      />

      <CtaBanner
        title="Klaar voor een zomer vol speelplezier?"
        text="Bekijk het programma en plan jullie bezoek aan Mechelen Beach 2026."
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        image={IMAGES.kidsActKabouter}
      />
    </>
  );
}
